import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";

import { setMessage } from "../../redux/slices/snackbarSlice";
import { useTranslation } from "react-i18next";

import MenuList from "@mui/material/MenuList";
import { Box } from "@mui/material";

import { useSearchParams } from "react-router-dom";

import ModalDialog from "../meters/ModalDialog";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "../../redux/slices/iwdWebSocketSlice";

import { loadingOff, loadingOn } from "../../redux/slices/loadingSlice";
import { store } from "../../redux/store";

const ExportTrilliantButton = ({ styleProp, paramsList }) => {
  const url = `${window.BASE_URL}/api/v1/altior/download/device/export?`;
  const bearer = localStorage.getItem("user_token");

  const [isOptionDisabled, setIsOptionDisabled] = useState(false);
  const [
    exportTrilliantMeters,
    {
      isLoading: isDeviceExportLoading,
      isSuccess: isDeviceExportSuccess,
      isError: isDeviceExportError,
      data: resultStartExport,
      isFetching,
      requestId,
    },
  ] = store.useExportTrilliantMetersMutation();
  const options = ["Export XLSX" /* "Export Trilliant" */];
  const loading = useSelector((state) => state?.loadingSlice?.loading);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [uuid, setUUID] = useState();
  const [startDownload, setStartDownload] = useState(false);
  const dispatch = useDispatch();
  let [searchParams] = useSearchParams();
  useEffect(() => {}, [url]);

  const { isWSConnected, subscribedChannels, data, error, channels } =
    useSelector((state) => state.iwdWebSocketSlice);
  const { t } = useTranslation();

  const hasValue = (obj) => {
    if (obj === null || obj === undefined) {
      return false;
    }

    if (typeof obj !== "object") {
      return true;
    }

    return Object.values(obj).some((value) => hasValue(value));
  };
  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };
  const filterObjectByValue = (obj) => {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      const filteredValue = filterObjectByValue(value);
      if (
        filteredValue !== "" &&
        filteredValue !== null &&
        filteredValue !== undefined
      ) {
        if (isObjectEmpty(filteredValue)) {
          return acc;
        }
        acc[key] = filteredValue;
      }
      return acc;
    }, {});
  };

  useEffect(() => {}, [paramsList]);
  useEffect(() => {
    if (isWSConnected && !channels["export_status"]) {
      let requestUuid = uuidv4();
      setUUID(requestUuid);

      dispatch(
        actions.joinChannel({
          name: "export_status",
          params: { uuid: requestUuid },
        })
      );
    }
  }, [isWSConnected]);
  useEffect(() => {
    if (isDeviceExportSuccess) {
      dispatch(setMessage(t("succ_exp")));
    }
  }, [isDeviceExportSuccess]);
  useEffect(() => {
    if (selectedIndex === 1 && hasValue(paramsList)) {
      setIsOptionDisabled(true);
    } else {
      setIsOptionDisabled(false);
    }
  }, [paramsList, selectedIndex]);
  useEffect(() => {}, [isOptionDisabled]);
  useEffect(() => {
    if (
      data &&
      data?.data_update?.uuid == uuid &&
      data?.data_update?.status == "ready"
    ) {
      const copySearchParams = new URLSearchParams(searchParams);
      copySearchParams.append("download_type", "excel");
      copySearchParams.append("uuid", uuid);
      copySearchParams.append("token", bearer);
      window.open(`${url}${copySearchParams.toString()}`, "_blank");
      dispatch(loadingOff());
    }
  }, [data, data?.data_update]);

  useEffect(() => {
    if (
      channels["export_status"] &&
      (!subscribedChannels["export_status"] ||
        !subscribedChannels["export_status"]["data_update"])
    ) {
      dispatch(
        actions.subscribeChannel({
          channelName: "export_status",
          eventName: "data_update",
        })
      );

      if (startDownload) {
        const copySearchParams = new URLSearchParams(searchParams);

        copySearchParams.append("download_type", "excel");
        copySearchParams.append("uuid", uuid);
        exportTrilliantMeters(copySearchParams);
        setStartDownload(false);
      }
    }
  }, [channels]);

  useEffect(() => {
    if (!isFetching) {
      switch (resultStartExport) {
        case "already_created":
          const copySearchParams = new URLSearchParams(searchParams);
          copySearchParams.append("download_type", "excel");
          copySearchParams.append("uuid", uuid);
          copySearchParams.append("token", bearer);
          window.open(`${url}${copySearchParams.toString()}`, "_blank");
          dispatch(loadingOff());
          break;
        case "creating":
          dispatch(loadingOn());
          break;
        default:
          break;
      }
    }
  }, [
    isDeviceExportSuccess,
    isDeviceExportLoading,
    requestId,
    resultStartExport,
    isFetching,
  ]);

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);

    switch (selectedIndex) {
      case 0:
        dispatch(loadingOn());
        if (!isWSConnected) {
          dispatch(actions.connect());
          setStartDownload(true);
        } else {
          const copySearchParams = new URLSearchParams(searchParams);
          copySearchParams.append("download_type", "excel");
          copySearchParams.append("uuid", uuid);

          exportTrilliantMeters(copySearchParams);
        }

        break;

      default:
        alert("Nothing to do");
        break;
    }
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  useEffect(() => {
    //clean up

    return () => {
      dispatch(actions.cleanData("data_update"));
      dispatch(actions.leaveChannel("export_status"));
    };
  }, []);

  return (
    <>
      {bearer && (
        <>
          <ModalDialog open={loading} title={t("note")} cancell={false}>
            <Box>{t("exporting_data")}</Box>
          </ModalDialog>
          <Box sx={styleProp}>
            <ButtonGroup
              variant={window.BUTTON_TYPE}
              ref={anchorRef}
              aria-label="split button"
            >
              <Button
                disabled={selectedIndex === 1 && !hasValue(paramsList)}
                onClick={handleClick}
              >
                {options[selectedIndex]}
              </Button>
              <Button
                size="small"
                aria-controls={open ? "split-button-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <ArrowDropDownIcon />
              </Button>
            </ButtonGroup>
            <Popper
              sx={{
                zIndex: 1,
              }}
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {options?.map((option, index) => (
                          <MenuItem
                            key={option}
                            selected={index === selectedIndex}
                            onClick={(event) =>
                              handleMenuItemClick(event, index)
                            }
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        </>
      )}
    </>
  );
};

export default ExportTrilliantButton;
